import axios from '../axios'

/*
 * 陪玩师推荐列表
 */

export const selectByPage = (data) => {
    return axios({
        url: '/memberTechnologyRecommend/v2/selectRecommendByPage',
        method: 'post',
        data
    })
}

export const batchRecommend = (data) => {
    return axios({
        url: '/memberTechnologyRecommend/batchRecommend',
        method: 'post',
        data
    })
}


export const batchCancelRecommend = (data) => {
    return axios({
        url: '/memberTechnologyRecommend/batchCancelRecommend',
        method: 'post',
        data
    })
}

export const batchTop = (data) => {
    return axios({
        url: '/memberTechnologyRecommend/batchTop',
        method: 'post',
        data
    })
}

export const batchCancelTop = (data) => {
    return axios({
        url: '/memberTechnologyRecommend/batchCancelTop',
        method: 'post',
        data
    })
}

export const adjustSort = (data) => {
    return axios({
        url: '/memberTechnologyRecommend/adjustSort',
        method: 'post',
        data
    })
}




// WEBPACK FOOTER //
// ./src/http/play/recommend.js